import { Box } from '@mui/material';
import type { BoardLayout } from '../../types/domain';

interface BoardLayoutPreviewProps {
  layout: BoardLayout;
  size?: number;
}

/** Miniatury layoutů pro admin volbu layoutu na televizi/projektoru. */
export const BoardLayoutPreview = ({ layout, size = 80 }: BoardLayoutPreviewProps) => {
  const vb = '0 0 160 90';
  return (
    <Box sx={{ width: size * 1.78, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg viewBox={vb} width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="6" fill="#F5F5F5" stroke="#E0E0E0" />
        {layout === 'MATRIX' && (
          <>
            {/* 2x3 grid buněk */}
            {[0, 1, 2].map((col) =>
              [0, 1].map((row) => (
                <rect
                  key={`${col}-${row}`}
                  x={8 + col * 36}
                  y={10 + row * 32}
                  width="32"
                  height="28"
                  rx="2"
                  fill="#FFFFFF"
                  stroke="#BDBDBD"
                />
              )),
            )}
            {/* QR panel vpravo */}
            <rect x="120" y="10" width="32" height="70" rx="2" fill="#FFFFFF" stroke="#BDBDBD" />
            <rect x="128" y="28" width="16" height="16" fill="#212121" />
          </>
        )}
        {layout === 'FOCUS' && (
          <>
            {/* velká karta nahoře */}
            <rect x="8" y="10" width="116" height="50" rx="3" fill="#FFB300" />
            <rect x="16" y="20" width="40" height="6" fill="#FFFFFF" opacity="0.9" />
            <rect x="16" y="32" width="80" height="8" fill="#FFFFFF" opacity="0.95" />
            <rect x="16" y="44" width="60" height="8" fill="#FFFFFF" opacity="0.85" />
            {/* malé karty dole */}
            {[0, 1, 2].map((c) => (
              <rect key={c} x={8 + c * 40} y={66} width="36" height="18" rx="2" fill="#CFD8DC" />
            ))}
            {/* QR v rohu */}
            <rect x="130" y="14" width="22" height="22" fill="#212121" />
          </>
        )}
        {layout === 'CAROUSEL' && (
          <>
            <rect width="160" height="90" rx="6" fill="#0A0A0A" />
            {/* top bar */}
            <rect x="10" y="8" width="60" height="6" fill="#FFB300" />
            <rect x="10" y="18" width="40" height="4" fill="#9E9E9E" />
            {/* řádky */}
            {[30, 44, 58, 72].map((y, i) => (
              <g key={i}>
                <rect x="10" y={y} width="10" height="10" fill={i === 0 ? '#FFD54F' : i === 1 ? '#CFD8DC' : i === 2 ? '#D4A373' : '#424242'} />
                <rect x="24" y={y + 2} width="80" height="6" fill="#E0E0E0" />
                <rect x="110" y={y + 2} width="28" height="6" fill={i === 0 ? '#FFD54F' : '#9E9E9E'} />
              </g>
            ))}
            {/* QR v rohu */}
            <rect x="136" y="8" width="16" height="16" fill="#FFFFFF" />
          </>
        )}
        {layout === 'COLUMNS' && (
          <>
            {/* 4 sloupce per kategorie */}
            {[0, 1, 2, 3].map((col) => (
              <g key={col}>
                {/* hlavička sloupce */}
                <rect
                  x={6 + col * 34}
                  y={8}
                  width={30}
                  height={8}
                  rx={1.5}
                  fill="#C62828"
                />
                {/* tabulky disciplín */}
                {[0, 1, 2].map((row) => (
                  <rect
                    key={row}
                    x={6 + col * 34}
                    y={20 + row * 16}
                    width={30}
                    height={12}
                    rx={1.5}
                    fill="#FFFFFF"
                    stroke="#BDBDBD"
                  />
                ))}
                {/* celkové pořadí */}
                <rect
                  x={6 + col * 34}
                  y={70}
                  width={30}
                  height={14}
                  rx={1.5}
                  fill="#FFE082"
                  stroke="#F9A825"
                />
              </g>
            ))}
            {/* QR v rohu */}
            <rect x={142} y={8} width={12} height={12} fill="#212121" />
          </>
        )}
        {layout === 'SPLIT' && (
          <>
            {/* horní matrix zkratka */}
            {[0, 1, 2, 3].map((col) => (
              <rect key={col} x={8 + col * 30} y={10} width="26" height="30" rx="2" fill="#FFFFFF" stroke="#BDBDBD" />
            ))}
            {/* dolní focus */}
            <rect x="8" y="48" width="116" height="34" rx="3" fill="#FFB300" />
            <rect x="16" y="56" width="60" height="6" fill="#FFFFFF" opacity="0.9" />
            <rect x="16" y="68" width="40" height="8" fill="#FFFFFF" opacity="0.95" />
            {/* QR v rohu */}
            <rect x="130" y="52" width="22" height="22" fill="#212121" />
          </>
        )}
      </svg>
    </Box>
  );
};
